var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cargo-advance-select",
    _vm._g(
      _vm._b(
        {
          ref: "cargoAdvanceSelect",
          attrs: {
            "select-type": _vm.selectType,
            "method-params": _vm.methodParams,
            disabled: _vm.disabled,
            filterable: _vm.filterable || _vm.allowCreate,
            "allow-create": _vm.allowCreate,
            "default-value": _vm.innerDefaultValue,
            "static-options": _vm.staticOptions
          }
        },
        "cargo-advance-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }